import { css, l, type ClassComponent } from "./lib";

export class YourProblemsAndTasks implements ClassComponent<HTMLDivElement> {
    mount(): HTMLDivElement {
        return l('div', _ => {
            // FIXME: use gap instead of margin-top
            css`
                display: flex;
                flex-wrap: wrap;
                gap: 40px;
                justify-content: space-between;
            `.apply(_)
            css`
                @media(max-width: 1058px) {
                    .this-class {
                        justify-content: center;
                    }
                }
            `.apply(_)
            _.id = "contacts"
            l(_, 'div', _ => {
                css`
                    height: clamp(222px, 27.08vw, 325px);
                    max-width: 597px;
                    text-align: left;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    gap: 20px;
                `.apply(_)

                l(_, 'h2', _ => {
                    css`
                        font-family: Cormorant Garamond;
                        font-size: clamp(32px, 5vw, 60px);
                        font-weight: 300;
                        color: #001F19;
                    `.apply(_)
                    _.innerText = 'ОБСУДИМ ВАШИ ПРОБЛЕМЫ, ЗАДАЧИ И ЦЕЛИ?';
                })
                l(_, 'p', _ => {
                    css`
                        font-size: 18px;
                        color: #48514F;
                    `.apply(_)
                    _.innerText = 'Напишите нам в свободной форме в мессенджеры или на почту,' +
                        ' мы ответим в течение дня, зададим вопросы и оценим проект'
                })
            })
            l(_, 'div', _ => {
                css`
                    height: 325px;
                    display: flex;
                    overflow-x: auto;
                    gap: 20px;
                    scrollbar-width: thin;

                    &>div {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        padding: 32px;
                        border-radius: 12px;
                        min-width: max(265px, min(350px, calc(100vw - 20px - 30px - 30px)));
                        max-width: 350px;
                        flex-shrink: 0;
                        flex-grow: 1;
                        background-color: var(--base-color-backgound-gray);

                        &>div:nth-child(1) {
                            display: flex;
                            gap: 10px;
                            flex-direction: column;
                        }

                        &>div>p:nth-child(1) {
                            font-size: 14px;
                            color: var(--base-color-dark-green);
                        }

                        &>div>p:nth-child(2) {
                            font-size: 18px;
                        }
                    }
                    
                `.apply(_)

                l(_, 'div', _ => {
                    l(_, 'div', _ => {
                        l(_, 'p', _ => { _.innerText = 'Мессенджеры' })
                        l(_, 'p', _ => { _.innerText = '+7 913 610 67 42' })
                    })

                    l(_, 'div', _ => {
                        css`
                            display: flex;
                            gap: 10px;

                            &>a {
                                width: 50px;
                                height: 50px;
                                background-repeat: no-repeat;
                                background-position: 8px 8px;
                                border: 1.48px solid #2ACBB0;
                                border-radius: 4px;
                            }
                        `.apply(_)

                        l(_, 'a', _ => {
                            css`
                                background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M27.4199 3.05603C26.4887 2.40478 25.3162 2.30728 24.2874 2.79728L2.42742 14.3123C0.787419 15.176 0.88367 17.5385 2.57242 18.2998C2.93367 18.4623 3.24867 18.5848 3.49492 18.6523L6.17492 19.3223C7.09867 19.5548 8.08867 19.3835 8.88367 18.8535L20.2437 10.1298C20.5024 9.93229 20.8674 9.96354 21.0849 10.2035C21.3049 10.441 21.3049 10.8073 21.0862 11.0473L12.9062 20.0085C12.5412 20.376 12.3724 20.8535 12.4262 21.3398C12.4799 21.826 12.7474 22.2548 13.1599 22.5173L13.2037 22.5398L23.1349 27.2685C24.6562 27.9935 26.4374 26.9985 26.6199 25.3235L28.7337 5.90979C28.8437 4.77604 28.3537 3.70978 27.4199 3.05603Z" fill="%232ACBB0"/></svg>');
                            `.apply(_)
                            _.ariaLabel="написать в телеграмм"
                            _.href = "https://t.me/aka_naked_gun"
                            _.target = "_blank"
                        })
                        l(_, 'a', _ => {
                            css`
                                background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M12.9138 2.66901C7.91633 3.47651 3.82382 7.37901 2.78132 12.3328C2.07007 15.7078 2.75257 18.8878 4.32007 21.4703L3.77132 26.0378C3.61257 26.9615 4.49007 27.724 5.38258 27.4403L9.39883 26.1628C11.7426 27.3415 14.4976 27.8265 17.4076 27.269C22.5051 26.2928 26.5588 22.1128 27.3476 16.9815C28.6513 8.49651 21.4101 1.29526 12.9138 2.66901ZM21.1988 19.3915C21.1088 19.944 20.7713 20.4228 20.2838 20.6965C19.5551 21.1053 18.5988 21.3403 17.7126 21.2178C16.7913 21.0903 15.8251 20.6753 14.8538 20.0678C13.2588 19.1203 12.1376 17.9415 12.0663 17.8665C12.0288 17.834 10.8238 16.6765 9.86633 15.0403C9.29383 14.104 8.90132 13.1728 8.77882 12.284C8.77507 12.2578 8.77883 12.2315 8.77507 12.2053C8.77507 12.204 8.77383 12.2028 8.77383 12.2015C8.67633 11.339 8.90383 10.4203 9.30008 9.71276C9.57383 9.22526 10.0526 8.88776 10.6051 8.79776C11.0626 8.72276 11.6588 8.69776 12.2176 8.89527C12.3788 8.95276 12.5226 9.06651 12.6276 9.20151C13.1438 9.87027 13.5063 10.6628 13.6713 11.1415C13.7838 11.4678 13.6963 11.824 13.4601 12.0728L13.3413 12.1915L12.4751 13.019C12.4751 13.019 12.4751 13.039 12.4763 13.0578L11.9251 13.609C12.5538 14.7378 13.4263 15.714 13.8401 16.1053C13.8963 16.1628 14.9888 17.3053 16.3888 18.074L16.9401 17.5228C16.9576 17.5228 16.9788 17.524 16.9788 17.524L17.8051 16.659L17.9238 16.5403C18.1726 16.304 18.5288 16.2178 18.8551 16.329C19.3338 16.494 20.1276 16.8565 20.7951 17.3728C20.9313 17.4778 21.0451 17.6203 21.1013 17.7828C21.2988 18.3378 21.2738 18.934 21.1988 19.3915Z" fill="%232ACBB0"/></svg>');
                            `.apply(_)
                            _.ariaLabel="написать в whatsapp"
                            _.href = "https://wa.me/79059221424"
                            _.target = "_blank"
                        })
                        l(_, 'a', _ => {
                            css`
                                width: 110px !important;
                                background-position: 20px 13px !important;
                                background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="65" height="21" viewBox="0 0 65 21" fill="none"><g clip-path="url(%23clip0_551_1336)"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.6282 20.7326C8.59352 20.7326 7.64797 20.4356 6.00441 19.2474C4.96481 20.5841 1.67273 21.6286 1.52916 19.8415C1.52916 18.4999 1.23213 17.3663 0.895498 16.1286C0.494508 14.6039 0.0390625 12.9059 0.0390625 10.4455C0.0390625 4.56923 4.86085 0.148438 10.5737 0.148438C16.2915 0.148438 20.7717 4.78705 20.7717 10.4999C20.781 13.2012 19.7181 15.7958 17.8163 17.7142C15.9146 19.6326 13.3294 20.7182 10.6282 20.7326ZM10.7123 5.22765C7.93015 5.08408 5.76184 7.00983 5.28164 10.0296C4.8856 12.5296 5.58857 15.5742 6.18758 15.7326C6.47471 15.8019 7.19748 15.2177 7.64797 14.7673C8.39289 15.2819 9.26034 15.5909 10.1628 15.6633C11.5486 15.7299 12.9052 15.2503 13.9411 14.3273C14.977 13.4044 15.6094 12.1119 15.7024 10.7276C15.7566 9.34053 15.2641 7.98757 14.3308 6.9599C13.3976 5.93223 12.0982 5.31198 10.7123 5.2326V5.22765Z" fill="%232ACBB0"/><path d="M29.8543 15.9151H27.6562V5.51908H31.2355L33.6315 12.6527H33.9533L36.4533 5.51908H39.9533V15.9151H37.7503V8.19234H37.4335L34.7107 15.9151H32.7751L30.1761 8.19234H29.8543V15.9151ZM46.8295 16.1131C45.8543 16.1131 44.983 15.8854 44.2058 15.4349C43.4372 14.9712 42.8092 14.3073 42.3889 13.5141C41.9536 12.6469 41.7345 11.6873 41.7503 10.7171C41.7503 9.67749 41.9632 8.7468 42.3939 7.93492C42.8063 7.13617 43.4361 6.47029 44.2107 6.01412C45.0026 5.54508 45.9092 5.30514 46.8295 5.32106C47.6959 5.32106 48.4632 5.50422 49.1266 5.87551C49.7949 6.2369 50.3394 6.67749 50.7652 7.19729L51.2454 5.51412H52.9731V15.9102H51.2553L50.7751 14.2319C50.3157 14.7764 49.7582 15.2298 49.1315 15.5686C48.4238 15.9404 47.6338 16.1277 46.8345 16.1131H46.8295ZM47.3889 14.0537C48.3642 14.0537 49.1463 13.7468 49.7503 13.1329C50.0568 12.812 50.2958 12.4328 50.4531 12.0179C50.6104 11.6029 50.6829 11.1606 50.6662 10.7171C50.6662 9.727 50.3592 8.92997 49.7503 8.3161C49.4448 8.00232 49.0766 7.75639 48.6698 7.59433C48.2629 7.43227 47.8265 7.35771 47.3889 7.37551C46.4285 7.37551 45.6513 7.68739 45.0523 8.3161C44.7486 8.63535 44.5124 9.01246 44.3576 9.42496C44.2028 9.83746 44.1326 10.2769 44.1513 10.7171C44.1513 11.7022 44.4483 12.5092 45.0523 13.1329C45.357 13.4395 45.722 13.6796 46.1242 13.8381C46.5263 13.9966 46.957 14.07 47.3889 14.0537ZM56.9483 15.9151H54.3493L57.6464 10.5933L54.7256 5.51908H57.3295L59.2652 9.01412H59.6464L61.686 5.51908H64.2256L61.3048 10.4547L64.6067 15.9151H61.9236L59.7058 11.9745H59.3246L56.9483 15.9151Z" fill="%232ACBB0"/></g><defs><clipPath id="clip0_551_1336"><rect width="64.8515" height="20.7921" fill="white"/></clipPath></defs></svg>');
                            `.apply(_)
                            _.ariaLabel="написать в MAX"
                            _.href = "https://max.ru/u/f9LHodD0cOKmvg8gLFGsumaeYQEtRf15jMXKuSkrO0Ujh87X6Jczq5vvadk"
                            _.target = "_blank"
                        })
                    })
                })
                l(_, 'div', _ => {
                    l(_, 'div', _ => {
                        l(_, 'p', _ => { _.innerText = 'Почта' })
                        l(_, 'p', _ => { _.innerText = 'welcome@web280.ru' })
                    })
                    l(_, 'div', _ => {
                        css`
                            display: flex;
                            gap: 10px;

                            &>a {
                                width: 50px;
                                height: 50px;
                                background-repeat: no-repeat;
                                background-position: 0px 0px;
                            }
                        `.apply(_)

                        l(_, 'a', _ => {
                            css`
                                background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none"><path d="M12.5 12.5H37.5M37.5 12.5V37.5M37.5 12.5L14.2857 35.7143" stroke="%232ACBB0" stroke-width="4.16667"/></svg>');
                            `.apply(_)
                            _.ariaLabel="написать на почту"
                            _.href = "mailto:welcome@web280.ru"
                            _.target = "_blank"
                        })
                    })
                })
            })
        })
    }
}